import Vue from 'vue';
import VueResource from 'vue-resource';
import formatarData from '~js/formatar-data';
import converterMoeda from '~js/converter-moeda';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarParaVisualizar(relatorioTecnico) {
  if (!((relatorioTecnico.atividadesIniciadas === undefined) || (relatorioTecnico.atividadesIniciadas === null))) {
    relatorioTecnico.atividadesIniciadas = relatorioTecnico.atividadesIniciadas ? "true" : "false";
  }

  if (!((relatorioTecnico.cronogramaCumprido === undefined) || (relatorioTecnico.cronogramaCumprido === null))) {
    relatorioTecnico.cronogramaCumprido = relatorioTecnico.cronogramaCumprido ? "true" : "false";
  }

  if (!((relatorioTecnico.planoOrcamentoCumprido === undefined) || (relatorioTecnico.planoOrcamentoCumprido === null))) {
    relatorioTecnico.planoOrcamentoCumprido = relatorioTecnico.planoOrcamentoCumprido ? "true" : "false";
  }

  if (!((relatorioTecnico.normasRespeitadas === undefined) || (relatorioTecnico.normasRespeitadas === null))) {
    relatorioTecnico.normasRespeitadas = relatorioTecnico.normasRespeitadas ? "true" : "false";
  }

  if (!((relatorioTecnico.intercorrencia === undefined) || (relatorioTecnico.intercorrencia === null))) {
    relatorioTecnico.intercorrencia = relatorioTecnico.intercorrencia ? "true" : "false";
  }

  if (!((relatorioTecnico.lei95894 === undefined) || (relatorioTecnico.lei95894 === null))) {
    relatorioTecnico.lei95894 = relatorioTecnico.lei95894 ? "true" : "false";
  }

  if (!((relatorioTecnico.projetoAndamento === undefined) || (relatorioTecnico.projetoAndamento === null))) {
    relatorioTecnico.projetoAndamento = relatorioTecnico.projetoAndamento ? "true" : "false";
  }

  if ((relatorioTecnico.idResponsavelEnvio === undefined) || (relatorioTecnico.idResponsavelEnvio === null)) {
    relatorioTecnico.idResponsavelEnvio = 0;
  }

  return relatorioTecnico;
}

function normalizarParaSalvar(relatorioTecnico) {
  relatorioTecnico.atividadesIniciadas = relatorioTecnico.atividadesIniciadas === "true" ? true : false;
  relatorioTecnico.cronogramaCumprido = relatorioTecnico.cronogramaCumprido === "true" ? true : false;
  relatorioTecnico.planoOrcamentoCumprido = relatorioTecnico.planoOrcamentoCumprido === "true" ? true : false;
  relatorioTecnico.normasRespeitadas = relatorioTecnico.normasRespeitadas === "true" ? true : false;
  relatorioTecnico.intercorrencia = relatorioTecnico.intercorrencia === "true" ? true : false;
  relatorioTecnico.lei95894 = relatorioTecnico.lei95894 === "true" ? true : false;
  relatorioTecnico.projetoAndamento = relatorioTecnico.projetoAndamento === "true" ? true : false;
  
  return relatorioTecnico;
}

function normalizarPlanoTrabalho(planotrabalho) {

  for (var i = 0; i < planotrabalho.length; i++) {
    planotrabalho[i].quantidadePrevista = converterMoeda.paraDolar(planotrabalho[i].quantidadePrevista);
    planotrabalho[i].quantidadeExecutada = converterMoeda.paraDolar(planotrabalho[i].quantidadeExecutada);

    if (planotrabalho[i].quantidadeExecutada == "")
      planotrabalho[i].quantidadeExecutada = 0.0

    if (planotrabalho[i].projetoPlanoTrabalhoMeta != null) {
      delete planotrabalho[i].projetoPlanoTrabalhoMeta;
    }
  }  

  return planotrabalho;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);
    return Vue.http.get('/api/relatorioTecnicoProjeto', { params: parametros });
  },
  alterar: (relatorioTecnico, arquivos, id) => {
    relatorioTecnico = normalizarParaSalvar(relatorioTecnico);
    relatorioTecnico.arquivos = arquivos;

    relatorioTecnico = converterObjetoFormData(relatorioTecnico);

    return Vue.http.put(`/api/relatorioTecnicoProjeto/${id}`, relatorioTecnico).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/relatorioTecnicoProjeto/${id}`)
      .then(response => normalizarParaVisualizar(response.body));
  },
  arquivos: id => {
    return Vue.http.get(`/api/relatorioTecnicoProjeto/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/relatorioTecnicoProjeto/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
  obterPlanoTrabalho: id => {
    return Vue.http.get(`/api/relatorioTecnicoProjeto/${id}/planotrabalho`)
      .then(response => response.body);
  },
  alterarPlanoTrabalho: (planotrabalho, id) => {
    planotrabalho = normalizarPlanoTrabalho(planotrabalho);

    var copiaplanotrabalho = JSON.stringify(planotrabalho);

    return Vue.http.put(`/api/relatorioTecnicoProjeto/${id}/planotrabalho`, copiaplanotrabalho).then(res => res.data.id);
  },
  obterPlanoTrabalhoEquipe: id => {
    return Vue.http.get(`/api/relatorioTecnicoProjeto/${id}/planotrabalhoequipe`)
      .then(response => response.body);
  },
  obterPlanoTrabalhoAquisicoes: id => {
    return Vue.http.get(`/api/relatorioTecnicoProjeto/${id}/planotrabalhoaquisicoes`)
      .then(response => response.body);
  },
  liberar: id => {
    return Vue.http.post(`/api/relatorioTecnicoProjeto/${id}/liberar`)
      .then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/relatorio-tecnico-projeto/servico.js